import { API_URL } from '../../../app-config/constants';
import ObjectiveCycleDto from '../../../types/ObjectiveCycleDto';
import { get, post, put, remove } from '../request';

getById.operation = 'READ';
getById.byId = true;
export function getById(id: string): Promise<ObjectiveCycleDto> {
    return get(`${API_URL}/objective-cycles/` + id);
}

list.operation = 'READ';
export function list(excludeCompleted = false, excludeArchived = false): Promise<ObjectiveCycleDto[]> {
    return get(`${API_URL}/objective-cycles`, {
        getData: {
            excludeCompleted,
            excludeArchived,
        },
    });
}

export function setPermissions(id: string, userIds: string[]) {
    return put(`${API_URL}/objective-cycles/${id}/permissions`, { postData: userIds });
}

export function addPermissions(id: string, userIds: string[]) {
    return post(`${API_URL}/objective-cycles/${id}/permissions`, { postData: userIds });
}

export function removePermission(id: string, userId: string[]) {
    return remove(`${API_URL}/objective-cycles/${id}/permissions/${userId}`);
}
